// extracted by mini-css-extract-plugin
export default {"chipContainer":"styles_chipContainer__Xxhbb","iconContainer":"styles_iconContainer__7G0yL","noIconText":"styles_noIconText__SQ6Ef"};